export default __webpack_public_path__ + "static/controller-small-c735e747b98e9a15b9b1f3ba362eb9fa.svg";